import { storage } from './storage'

const AUTH_KEY = 'mock-auth'

export interface MockUser {
  email: string
}

export function getMockUser(): MockUser | null {
  return storage.get<MockUser | null>(AUTH_KEY, null)
}

export function setMockUser(user: MockUser): void {
  storage.set(AUTH_KEY, user)
}

export function clearMockUser(): void {
  storage.remove(AUTH_KEY)
}
